export class CanHaveTrialResponse {
  canHaveTrial: boolean;
  reason: CanHaveTrialReason;
  eligibleDate: Date;
}

export enum CanHaveTrialReason {
  NoIceHistory = 'NoIceHistory', //Eligible for trial
  RecentIceCustomerQuarantineExpired = 'RecentIceCustomerQuarantineExpired', //Eligible for trial
  HasActiveSubscription = 'HasActiveSubscription',
  InTrialQuarantine = 'InTrialQuarantine',
  HasActiveTrial = 'HasActiveTrial',
  InRecentIceCustomerQuarantine = 'InRecentIceCustomerQuarantine',
  Unknown = 'Unknown',
}
